import { MAX_CONTENT_WIDTH } from '@audi/audi-ui-design-tokens';
import {
	SYS_BREAKPOINT_2_XL,
	SYS_BREAKPOINT_LG,
	SYS_BREAKPOINT_MD,
	SYS_BREAKPOINT_SM,
	SYS_BREAKPOINT_XL,
	SYS_PAGE_MARGIN_2_XL,
	SYS_PAGE_MARGIN_LG,
	SYS_PAGE_MARGIN_MD,
	SYS_PAGE_MARGIN_SM,
	SYS_PAGE_MARGIN_XL,
} from '@oneaudi/unified-web-common';
import styled from 'styled-components';

export const Container = styled.div<{ isFullSize?: boolean }>`
	width: 100%;
	max-width: ${(props) => (props.isFullSize ? 2545 : MAX_CONTENT_WIDTH)}px;
	margin-left: auto;
	margin-right: auto;
`;

export const InnerContainer = styled.div<{ removeSpaces?: boolean }>`
	${(props) => {
		if (props.removeSpaces) return;

		return `
		padding: 0 ${SYS_PAGE_MARGIN_SM};

		@media screen and (min-width: ${SYS_BREAKPOINT_SM}) {
			padding-left: ${SYS_PAGE_MARGIN_SM};
			padding-right: ${SYS_PAGE_MARGIN_SM};
		}

		@media screen and (min-width: ${SYS_BREAKPOINT_MD}) {
			padding-left: ${SYS_PAGE_MARGIN_MD};
			padding-right: ${SYS_PAGE_MARGIN_MD};
		}

		@media screen and (min-width: ${SYS_BREAKPOINT_LG}) {
			padding-left: ${SYS_PAGE_MARGIN_LG};
			padding-right: ${SYS_PAGE_MARGIN_LG};
		}

		@media screen and (min-width: ${SYS_BREAKPOINT_XL}) {
			padding-left: ${SYS_PAGE_MARGIN_XL};
			padding-right: ${SYS_PAGE_MARGIN_XL};
		}

		@media screen and (min-width: ${SYS_BREAKPOINT_2_XL}) {
			padding-left: ${SYS_PAGE_MARGIN_2_XL};
			padding-right: ${SYS_PAGE_MARGIN_2_XL};
		}
		`;
	}}
`;
